export class MiscAssistant {

    static debounce(callback, delay) {
        clearTimeout(window.debounceTimer)
        window.debounceTimer = setTimeout(() => {
            callback();
        }, delay)
    }

    static postData(url = "", data = {}) {
        return new Promise(async (resolve, reject) => {
            fetch(url, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                // mode: "no-cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    "Content-Type": "application/json",
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data), // body data type must match "Content-Type" header
            }).then(x => x.json())
                .then(data => {
                    resolve(data)
                })
        })
    }

    static renderTemplate(template, data) {
        return template.replace(/{{\s*([^}]+)\s*}}/g, (match, key) => data[key.trim()] || '');
    }

    static greek2greeklish(string) {
        const dictionary = {
            "α": "a",
            "β": "b",
            "ψ": "ps",
            "δ": "d",
            "ε": "e",
            "φ": "f",
            "γ": "g",
            "η": "i",
            "ι": "i",
            "ξ": "ks",
            "κ": "k",
            "λ": "l",
            "μ": "m",
            "ν": "n",
            "ο": "o",
            "π": "p",
            "ρ": "r",
            "σ": "s",
            "τ": "t",
            "θ": "th",
            "ω": "o",
            "ς": "s",
            "χ": "x",
            "υ": "u",
            "ζ": "z",
        };
        return Array.from(string).map(char => dictionary[char] || char).join('');
    }

}
